import { lazy, Suspense } from 'react';
import { BootstrapLoading } from './participant/BootstrapLoading.tsx';
import { CheckinPage } from './participant/CheckinPage.tsx';
import { EventUnavailable } from './participant/EventUnavailable.tsx';
import { Home } from './participant/Home.tsx';
import { resolveRoute } from './routes.ts';

/**
 * Every admin screen is loaded on demand, so none of it is in the bundle a
 * participant downloads on a venue network (§22).
 */
const EventReportPage = lazy(() =>
  import('./admin/EventReportPage.tsx').then((module) => ({ default: module.EventReportPage })),
);

const AdminHomePage = lazy(() =>
  import('./admin/AdminHomePage.tsx').then((module) => ({ default: module.AdminHomePage })),
);

const EventEditorPage = lazy(() =>
  import('./admin/EventEditorPage.tsx').then((module) => ({ default: module.EventEditorPage })),
);

/**
 * The entry points are `/e/:slug` (optionally `/e/:slug/:locationCode`, the
 * QR printed for one venue) for participants and `/admin*` for staff, plus a
 * landing screen at `/`. Which path means which screen is decided by
 * `resolveRoute`; this component only renders the answer.
 */
export function App() {
  const route = resolveRoute(window.location.pathname);

  switch (route.kind) {
    case 'participant':
      return <CheckinPage slug={route.slug} locationCode={route.locationCode} />;

    case 'home':
      return <Home />;

    case 'admin_home':
      return (
        <Suspense fallback={<BootstrapLoading />}>
          <AdminHomePage />
        </Suspense>
      );

    case 'event_report':
      return (
        <Suspense fallback={<BootstrapLoading />}>
          <EventReportPage eventId={route.eventId} />
        </Suspense>
      );

    case 'event_editor':
      return (
        <Suspense fallback={<BootstrapLoading />}>
          <EventEditorPage eventId={route.eventId} />
        </Suspense>
      );

    case 'redirect':
      // `replace`, not `assign`: the retired URL should not sit in the back
      // stack waiting to bounce the admin again.
      window.location.replace(route.to);
      return <BootstrapLoading />;

    case 'not_found':
    default:
      // Any other path is a mistyped or stale QR target as far as a
      // participant is concerned.
      return <EventUnavailable reason="not_found" />;
  }
}
